import React from "react";

import { Status, Protocol } from "./lib/constants";
import { MessageFactory } from "./lib/messages";
import GameUtils from "./lib/gameutils";
import { MessagesList } from "./lib/mines_msg";
import { WS } from "./lib/websocket";

import Mines from "./components/mines/Mines";
import AutoRollLogic from "./components/otherPages/autoRoll/AutoRollLogic";
import NoSignal from "./components/otherPages/noSignal/NoSignal";
import Notification from "./components/otherPages/notifications/Notification";
import { logger } from './components/helpers/logger'

import { AppContainer } from "./AppStyled";
class App extends React.Component {
  constructor(props) {
    super(props);

    this.WS_URL = "{{SERVER_WS_URL}}";
    this.hostname = window.location.hostname
    if (this.hostname === 'localhost') {
      this.WS_URL = 'wss://dev.orbitalgaming.io/websocketbridge/ws/mines'
    } else if (this.WS_URL.includes('SERVER_WS_URL')) {
      this.WS_URL = `wss://${this.hostname}/websocketbridge/ws/mines`
    }



    this.state = {
      user_id: null,
      balance: null,
      bet: null,
      bombs: null,
      userInfo: {
        minBet: null,
        maxBet: null,
        maxWin: null,
        curr: null,
        precision: null,
      },
      stateRound: {
        balance: null,
        bets: null,
        bombs: null,
        currentCoef: "",
        nextCoef: "",
        userSelected: [],
        board: [],
        winAmount: null,
      },
      provablyFairSeeds: {
        clientSeed: "",
        serverSeedSHA256: "",
        nonce: null,
        old_client_seed: "",
        old_server_seed: "",
        old_server_seed_SHA256: "",
        old_nonce: null,
        next_server_seedSHA256: "",
      },
      autoConfigs: {
        betInAuto: "0",
        max: "0",
        onLossReset: "1",
        onLossPercent: "0",
        onWinReset: "1",
        onWinPercent: "0",
        stopOnLoss: "0",
        stopOnProfit: "0",
        numberOfBets: "0",
      },
      userSettings: {
        music: "0",
        sound: "0",
        volume: "0",
      },
      volumeLocal: "0",
      errorMsg: {
        mainText: "",
        btnText: "",
        reload: false,
      },
      history: {
        myHistory: [],
        allHistory: [],
        highRoller: [],
      },
      betReply: null,
      isAutoOn: false,
      noSignal: false,
      notification: false,
      selectedSpheres: [],
      userSelected: [],
      above: false,
      aboveSetting: false,
      aboveSettingAnim: false,
      abovAnim: false,
      autoAnim: false,
      notificationfadeOut: false,
      notifyText: false,
      manualPlay: false,
      manualGameIsOn: "0",
      result: false,
      autoSelect: false,
      gamePlayAnimation: false,
      perfectWin: false,
      explosion: false,
      isDisabled: true,
      isClickable: false,
      dynamicSoundChange: false,
      gameStates: "init",
      newDisable: true,
    };
    this.autorollLogic = new AutoRollLogic();
    this.historyLocal = [];
    this.myHistoryLocal = [];
    this.highRollerLocal = [];
    this.Globals = {};
    //  // ak ra xdebaa :))
    this.myTimeout = null;
    this.notificationTimeOut = null;
    this.gameTimeOut = null;
    this.disableTimeOut = null;
    this.stopTimeout = null;
    this.autoAnimTimeOut = null;
  }
  componentDidMount() {
    window._mfq = window._mfq || [];
    (function () {
      var mf = document.createElement("script");
      mf.type = "text/javascript";
      mf.defer = true;
      mf.src =
        "https://cdn.mouseflow.com/projects/27d3415e-736e-4ff5-9a5c-1aa7729b351d.js";
      document.getElementsByTagName("head")[0].appendChild(mf);
    })();

  

    MessageFactory.messagesList = MessagesList;
    this.Globals.WS = new WS().Init(this).Start();
  }
  componentWillUnmount() {
    this.Globals.WS.Disconnect();
    this.setState({
      history: {
        myHistory: [],
        allHistory: [],
        highRoller: [],
      },
      isDisabled: true,
    });
  }

  setStatus(status) {
    logger.log("%cstatus = ", "color:brown", status);
    switch (status) {
      case Status.CONNECTED:
        logger.log("%cconnected ", "color:green");
        this.setState({ noSignal: false, reload: false });
        var session = GameUtils.getParameterByName("session");
        if (typeof session == "string") {
          var loginMsg = MessageFactory.createMessage(
            Protocol.LOGIN,
            GameUtils.getParameterByName("session") + "@1"
          );
          this.Globals.WS.sendMessage(loginMsg);
        } else {
          logger.log("not logged in" + status);
        }
        break;

      case Status.DISCONNECTED:
        logger.log("%cdisconnected ", "color:brown");
        this.setState({
          isAutoOn: false,
          noSignal: true,
          above: false,
          notifyText: false,
          aboveSetting: false,
          errorMsg: {
            mainText:
              "Your session has expired, please reload the page to continue",
            reload: true,
            btnText: false,
          },
        });
        // xz
        clearTimeout(this.myTimeout);
        clearTimeout(this.disableTimeOut);
        clearTimeout(this.gameTimeOut);
        clearTimeout(this.notificationTimeOut);
        clearTimeout(this.stopTimeout);
        break;

      default:
        break;
    }
  }
  doMessage = function (msg) {
    var msgObject = null;
    try {
      msgObject = MessageFactory.parseMessage(msg);
    } catch (e) {
      console.dir(e);
    }
    if (msgObject === null) {
      logger.log("doMessage msgObject === null ", msg);
      return;
    }
    switch (msgObject.type) {
      case Protocol.GAME_STATE:
        logger.log("%cGAME_STATE", "color:aqua", msgObject);
        // set initial states
        this.setState({
          balance: msgObject.balance,
          user_id: msgObject.user_id,
          userInfo: {
            minBet: msgObject.minBet,
            maxBet: msgObject.maxBet,
            maxWin: msgObject.maxwin,
            curr: msgObject.currency,
            precision: msgObject.precision,
          },
          isClickable: true,
          provablyFairSeeds: {
            server_seed_SHA256: msgObject.server_seed_SHA256,
            client_seed: msgObject.client_seed,
            nonce: msgObject.nonce,
            next_server_seed_SHA256: msgObject.next_server_seed_SHA256,
          },
        });
        if (this.state.manualGameIsOn === "1") {
          this.setState({
            isDisabled: true,
          });
        } else {
          const setState = this.setState.bind(this);
          this.myTimeout = setTimeout(() => {
            setState({ isDisabled: false });
          }, 500);
        }
        break;
      case Protocol.USER_SETTINGS_RESPONCE:
        let min = this.state.userInfo.minBet;
        let profit = 0;
        let loss = 0;
        if (msgObject.settings.split(";").length !== 13) {
          msgObject.settings = `1;1;0.5;0;0;0;0;0;${profit.toFixed(
            this.state.userInfo.precision
          )};${loss.toFixed(this.state.userInfo.precision)};${min};10;0`;
          const settings = MessageFactory.createMessage(
            Protocol.USER_SETTINGS,
            msgObject.settings
          );
          this.Globals.WS.sendMessage(settings);
        }
        let arr = msgObject.settings.split(";");
        if (arr[10] < min) {
          this.setState({
            bet: min,
          });
        } else if (arr[10] === "null") {
          this.setState({
            bet: min,
          });
        } else {
          this.setState({
            bet: arr[10],
          });
        }
        this.setState({
          bombs: arr[11],
          manualGameIsOn: arr[12],
          userSettings: {
            music: arr[0],
            sound: arr[1],
            volume: arr[2] <= 1 ? arr[2] : arr[2] / 100,
          },
          volumeLocal: arr[2],
          autoConfigs: {
            numberOfBets: arr[3],
            onWinReset: arr[4],
            onWinPercent: arr[5],
            onLossReset: arr[6],
            onLossPercent: arr[7],
            stopOnProfit: arr[8],
            stopOnLoss: arr[9],
          },
        });
        logger.log("%cUSER_SETTINGS", "color:aqua", msgObject.settings);
        break;
      case Protocol.HISTORY:
        this.historyLocal.unshift(msgObject);
        while (this.historyLocal.length > 18) {
          this.historyLocal.pop();
        }
        if (msgObject.user_id === this.state.user_id) {
          this.myHistoryLocal.unshift(msgObject);
          while (this.myHistoryLocal.length > 18) {
            this.myHistoryLocal.pop();
          }
        }
        if (msgObject.bigWin !== 0) {
          this.highRollerLocal.unshift(msgObject);
          while (this.highRollerLocal.length > 18) {
            this.highRollerLocal.pop();
          }
        }
        this.setState({
          history: {
            allHistory: this.historyLocal,
            myHistory: this.myHistoryLocal,
            highRoller: this.highRollerLocal,
          },
        });
        this.setState({
          ...this.state,
          history: {
            myHistory: this.myHistoryLocal,
            allHistory: this.historyLocal,
            highRoller: this.highRollerLocal,
          },
        });
        break;
      case Protocol.STATE_ROUND:
        logger.log("%cSTATE_ROUND", "color:aqua", msgObject);
        const setState = this.setState.bind(this);
        let {
          autorollLogic,
          Globals,
          handleNotification,
          handleInitGame,
          floorFigure,
        } = this;
        const {
          isAutoOn,
          selectedSpheres,
          bombs,
          manualGameIsOn,
          userInfo,
        } = this.state;
        this.setState({
          stateRound: msgObject,
          balance: msgObject.balance,
          dynamicSoundChange: true,
          newDisable: false,
        });
        const { winAmount, balance } = msgObject;
        this.setState((prevState) => ({
          stateRound: {
            ...prevState.stateRound,
            userSelected: msgObject.userSelected,
          },
        }));
        this.myTimeout = setTimeout(() => {
          setState({ isDisabled: false });
        }, 500);
        if (manualGameIsOn === "1") {
          switch (msgObject.state) {
            case 0:
              break;
            case 1:
              this.setState({
                isClickable: false,
                userSelected: msgObject.userSelected,
                manualPlay: true,
                gameStates: "started",
                newDisable: true,
              });
              this.saveIsManual("1");
              setTimeout(() => {
                this.setState({ newDisable: false });
              }, 500);
              break;
            case 2:
              this.setState({
                isClickable: false,
                explosion: true,
                newDisable: true,
              });
              setTimeout(() => {
                this.setState({ newDisable: false });
              }, 500);
              this.saveIsManual("0");
              this.gameTimeOut = setTimeout(function () {
                setState({
                  result: true,
                  gamePlayAnimation: true,
                  manualPlay: false,
                  gameStates: "end",
                });
                handleInitGame();
              }, 400);
              this.saveIsManual("0");
              break;
            case 3:
              this.setState({
                isClickable: false,
                result: true,
                gamePlayAnimation: true,
                manualPlay: false,
                gameStates: "end",
                newDisable: true,
              });
              this.saveIsManual("0");
              setTimeout(() => {
                this.setState({ newDisable: false });
              }, 500);
              this.handleInitGame();
              break;
            case 4:
              this.setState({
                isClickable: false,
                perfectWin: true,
                result: true,
                gamePlayAnimation: true,
                manualPlay: false,
                gameStates: "end",
                newDisable: true,
              });
              this.saveIsManual("0");
              setTimeout(() => {
                this.setState({ newDisable: false });
              }, 500);
              handleInitGame();
              break;
            default:
              break;
          }
        }
        let time = 1000;
        if (isAutoOn) {
          setState({
            autoAnim: true,
            bet: autorollLogic.bet,
          });
          this.autoAnimTimeOut = setTimeout(function () {
            setState({
              autoAnim: false,
            });
            clearTimeout(this.autoAnimTimeOut);
          }, 900);
          this.myTimeout = setTimeout(function () {
            let value = autorollLogic.nextStep(winAmount - autorollLogic.bet);
            if (+autorollLogic.bet > userInfo.maxBet) {
              setState({
                isAutoOn: false,
                isDisabled: true,
                selectedSpheres: [],
                userSelected: [],
              });
              handleNotification(
                `You've reached max stake - ${userInfo.maxBet.toFixed(
                  userInfo.precision
                )} ${userInfo.curr}`
              );
              this.disableTimeOut = setTimeout(function () {
                setState({ isDisabled: false });
                clearTimeout(this.disableTimeOut);
              }, 400);
              return;
            }
            if (+autorollLogic.bet > balance) {
              setState({
                isAutoOn: false,
                isDisabled: true,
                selectedSpheres: [],
                userSelected: [],
              });
              handleNotification("Not enough balance");
              this.disableTimeOut = setTimeout(function () {
                setState({ isDisabled: false });
                clearTimeout(this.disableTimeOut);
              }, 400);
              return;
            }
            switch (value) {
              case AutoRollLogic.ROLL_OK:
                Globals.WS.sendMessage(
                  MessageFactory.createMessage(
                    Protocol.AUTOBET,
                    +autorollLogic.bet,
                    parseInt(bombs),
                    selectedSpheres.join(":")
                  )
                );
                break;
              case AutoRollLogic.ROLL_STOP_ON_LOSS:
                setState({
                  isAutoOn: false,
                  selectedSpheres: [],
                  isDisabled: true,
                  userSelected: [],
                });
                handleNotification(
                  `Stopped on loss - ${floorFigure(
                    +autorollLogic.ggr,
                    userInfo.precision
                  )} ${userInfo.curr}`
                );
                this.disableTimeOut = setTimeout(function () {
                  setState({ isDisabled: false });
                  clearTimeout(this.disableTimeOut);
                }, 400);
                break;
              case AutoRollLogic.ROLL_STOP_ON_WIN:
                handleNotification(
                  `Stopped on  win - ${floorFigure(
                    +autorollLogic.ggr,
                    userInfo.precision
                  )} ${userInfo.curr}`
                );
                setState({
                  isAutoOn: false,
                  selectedSpheres: [],
                  isDisabled: true,
                  userSelected: [],
                });
                this.disableTimeOut = setTimeout(function () {
                  setState({ isDisabled: false });
                  clearTimeout(this.disableTimeOut);
                }, 400);
                break;
              case AutoRollLogic.ROLL_STOP_ON_NUMBETS:
                handleNotification("Stopped on a selected number of bets");
                setState({
                  isAutoOn: false,
                  selectedSpheres: [],
                  isDisabled: true,
                  userSelected: [],
                });
                this.disableTimeOut = setTimeout(function () {
                  setState({ isDisabled: false });
                  clearTimeout(this.disableTimeOut);
                }, 400);
                break;
              default:
                break;
            }
            clearTimeout(this.myTimeout);
            clearTimeout(this.autoAnimTimeOut);
          }, time);
        }
        this.disableTimeOut = setTimeout(function () {
          setState({ isDisabled: false });
          clearTimeout(this.disableTimeOut);
        }, 400);
        break;

      case Protocol.GET_SEEDS_RESPONCE:
        logger.log("%cGET_SEEDS_RESPONCE", "color:aqua", msgObject);
        this.setState({ provablyFairSeeds: msgObject });
        break;
      case Protocol.GET_ROUND_RESPONCE:
        logger.log("%cGET_ROUND_RESPONSE", "color:aqua", msgObject);
        this.setState({
          betReply: msgObject,
        });
        break;
      case Protocol.ERROR:
        console.error("doMessage error read " + msgObject.errorCode);
        if (this.state.isAutoOn) {
          this.toggleIsAutoOn(false);
        }
        switch (msgObject.errorCode) {
          case 1:
            console.error("CONCURRENT_CONNECTION");
            this.setState({
              noSignal: true,
              errorMsg: {
                mainText: "Another login has been detected",
                btnText: false,
                reload: true,
              },
            });
            break;
          case 2:
            console.error("INVALID_SESSION", msgObject);
            this.setState({
              noSignal: true,
              errorMsg: {
                mainText: "Something went wrong, please reload the page",
                errorBtn: false,
                reload: true,
              },
            });
            //start websocket or reload?
            break;
          case 3:
            console.error("INSUFFICIENT_FUNDS", msgObject);
            this.handleNotification("Not enough balance");
            this.setState({ isDisabled: false, newDisable: false });
            break;
          case 4:
            console.error("INVALID_BET_AMOUNT", msgObject);
            this.handleNotification("Invalid stake amount");
            this.setState({ isDisabled: false, newDisable: false });
            break;
          case 5:
            console.error("MONEY_TRANSFER_ERROR", msgObject);
            this.setState({
              noSignal: true,
              errorMsg: {
                mainText:
                  "Something went wrong, please reload the page",
                reload: true,
                btnText: false,
              },
            });
            break;
          case 6:
            console.error("INVALID_BET", msgObject);
            this.handleNotification("Invalid bet");
            this.setState({ isDisabled: false, newDisable: false });
            break;
          case 7:
            console.error("PF_NOT_SET", msgObject);
            this.setState({
              noSignal: true,
              errorMsg: {
                mainText: "Error saving seeds, please try again later",
                reload: true,
                btnText: false,
              },
            });
            break;
          case 8:
            console.error("CLIENT_SEED_ERROR", msgObject);
            this.setState({
              noSignal: true,
              errorMsg: {
                mainText:
                  "Length of the seed must be minimum 16  and maximum 128 symbols",
                reload: true,
                btnText: false,
              },
            });
            break;
          case 9:
            console.error("CLIENT_SEED_OK", msgObject);
            this.handleNotification("Provably fair seed set successfully");
            this.setState({ isDisabled: false, newDisable: false });
            break;
          case 10:
            console.error("SYSTEM_ERROR", msgObject);
            this.setState({
              noSignal: true,
              errorMsg: {
                mainText:
                  "Something went wrong, please reload the page",
                btnText: false,
                reload: true,
              },
            });
            break;
          case 11:
            console.error("INVALID_ACTION", msgObject);
            this.handleNotification("Invalid action");
            this.setState({ isDisabled: false, newDisable: false });
            break;
          case 13:
            console.error("NOT_FOUND", msgObject);
            this.handleNotification("Bet info is not found");
            this.setState({ isDisabled: false, newDisable: false });

            break;
          case 14:
            console.error("GAME_NOT_ACTIVE", msgObject);

            this.setState({
              noSignal: true,
              errorMsg: {
                mainText: "Game is not active",
                reload: true,
                btnText: false,
              },
            });
            break;
          case 16:
            console.error("INSUFFICIENT_FUNDS", msgObject);
            this.handleNotification("Not enough balance");
            this.setState({ isDisabled: false, newDisable: false });
            break;
          case 115:
            console.error("MAX_BET_LIMIT", msgObject);
            this.handleNotification("You have exceeded your betting limit");
            this.setState({ isDisabled: false, newDisable: false });
            break;
          default:
            console.error("ERROR", msgObject);
            this.setState({
              noSignal: true,
              errorMsg: {
                mainText:
                  "Something went wrong, please reload the page",
                btnText: false,
                reload: true,
              },
            });
            break;
        }
        break;
      default:
        break;
    }
  };

  saveUserSettings = (userSettings) => {
    const { autoConfigs, bet, bombs, manualGameIsOn } = this.state;
    const sets = Object.values(userSettings);
    const auto = Object.values(autoConfigs);
    const str = sets.concat(auto, bet, bombs, manualGameIsOn);
    const j = str.join(";");
    const settings = MessageFactory.createMessage(Protocol.USER_SETTINGS, j);
    this.Globals.WS.sendMessage(settings);
    this.setState({ dynamicSoundChange: false });
  };
  saveAutoConfigs = (autoConfigs) => {
    const { userSettings, bombs, manualGameIsOn } = this.state;
    const b = this.autorollLogic.base_bet;
    const sets = Object.values(userSettings);
    const str = sets.concat(autoConfigs, b, bombs, manualGameIsOn);
    const j = str.join(";");
    const settings = MessageFactory.createMessage(Protocol.USER_SETTINGS, j);
    this.Globals.WS.sendMessage(settings);
  };
  saveBet = (b) => {
    const { autoConfigs, userSettings, bombs, manualGameIsOn } = this.state;
    const sets = Object.values(userSettings);
    const auto = Object.values(autoConfigs);
    const str = sets.concat(auto, +b, bombs, manualGameIsOn);
    const j = str.join(";");
    const settings = MessageFactory.createMessage(Protocol.USER_SETTINGS, j);
    this.Globals.WS.sendMessage(settings);
  };
  saveMines = (m) => {
    const { autoConfigs, userSettings, bet, manualGameIsOn } = this.state;
    const sets = Object.values(userSettings);
    const auto = Object.values(autoConfigs);
    const str = sets.concat(auto, bet, m, manualGameIsOn);
    const j = str.join(";");
    const settings = MessageFactory.createMessage(Protocol.USER_SETTINGS, j);
    this.Globals.WS.sendMessage(settings);
  };
  saveIsManual = (m) => {
    const { autoConfigs, userSettings, bet, bombs } = this.state;
    const sets = Object.values(userSettings);
    const auto = Object.values(autoConfigs);
    const str = sets.concat(auto, bet, bombs, m);
    const j = str.join(";");
    const settings = MessageFactory.createMessage(Protocol.USER_SETTINGS, j);
    this.Globals.WS.sendMessage(settings);
  };

  handleNotification = (n) => {
    // if (!n) {
    //   this.setState({ notificationfadeOut: true });
    //   clearTimeout(this.notificationTimeOut);
    //   setTimeout(() => {
    //     this.setState({ notification: n, notificationfadeOut: false });
    //   }, 333);
    // }
    if (!!n) {
      this.setState({ notification: n });
      clearTimeout(this.notificationTimeOut);
      this.notificationTimeOut = setTimeout(() => {
        this.setState({ notificationfadeOut: true });
        setTimeout(() => {
          this.setState({ notification: false, notificationfadeOut: false });
        }, 333);
      }, 1666);
    }
  };
  handleAbove = (e) => this.setState({ above: e });

  handleSetting = (e) => {
    let time = 500;
    const setState = this.setState.bind(this);
    if (!e) {
      this.myTimeout = setTimeout(function () {
        setState({ aboveSetting: false });
      }, time);
      this.setState({ aboveSettingAnim: false });
    } else {
      this.setState({ aboveSettingAnim: true });
      setState({ aboveSetting: e });
    }
  };

  handleAboveAnim = (e) => this.setState({ aboveAnim: e });

  handleBombs = (e) => this.setState({ bombs: e });

  toggleIsAutoOn = (e) => {
    this.setState({ isAutoOn: e });
    if (!e) {
      clearTimeout(this.myTimeout);
    }
  };

  toggleClickable = (e) => this.setState({ isClickable: e });

  toggleIsDisabled = (e) => this.setState({ isDisabled: e }); //click on animated buttonns

  handleBetAmount = (b) => this.setState({ bet: b });

  handleResult = (e) => this.setState({ result: e });

  handleAutoSelect = (e) => this.setState({ autoSelect: e });

  handleAutoRollLogic = (e) => {
    this.autorollLogic.setSettings(...e);
    this.saveAutoConfigs([e[8], e[4], e[5], e[2], e[3], e[7], e[6]], e[0]);
  };

  // GAMEPLAY
  handleStartRound = (e) => {
    const { bombs, balance } = this.state;
    if (+balance >= +e) {
      this.setState({
        result: false,
        isClickable: true,
        gamePlayAnimation: false,
        explosion: false,
        perfectWin: false,
        isDisabled: false,
        manualGameIsOn: "1",
        newDisable: true,
      });
      this.Globals.WS.sendMessage(
        MessageFactory.createMessage(
          Protocol.START_ROUND,
          parseFloat(e),
          parseInt(bombs)
        )
      );
      this.setState((prevState) => ({
        stateRound: {
          ...prevState.stateRound,
          userSelected: [],
        },
      }));
      this.saveBet(e);
    } else {
      this.handleNotification("Not enough balance");
      this.setState({ isDisabled: false, newDisable: false });
    }
  };
  handleGameStep = (e) => {
    const { userSelected } = this.state;
    this.handleNotification(false, {});
    if (userSelected.includes(e) === false) {
      this.setState({ userSelected: [...userSelected, e] });
      this.Globals.WS.sendMessage(
        MessageFactory.createMessage(Protocol.STEP_ROUND, parseInt(e))
      );
    }
  };
  handleRandomGameStep = () => {
    const { userSelected } = this.state;
    let rand = Math.floor(Math.random() * 24);
    if (userSelected.includes(rand.toString()) && userSelected.length <= 24) {
      this.handleRandomGameStep();
    } else {
      this.setState({ userSelected: [...userSelected, rand] });
      this.Globals.WS.sendMessage(
        MessageFactory.createMessage(Protocol.STEP_ROUND, parseInt(rand))
      );
    }
  };
  handleAutoRoll = () => {
    const { selectedSpheres, bombs, balance } = this.state;
    let {
      Globals,
      autorollLogic,
      toggleIsAutoOn,
      handleNotification,
      handleAutoSelect,
    } = this;
    if (+balance < +autorollLogic.bet) {
      handleNotification("Not enough balance");
      this.setState({ isDisabled: false });
    } else {
      handleAutoSelect(false);
      toggleIsAutoOn(true);
      this.setState({
        isDisabled: false,
        stateRound: {
          board: [],
        },
      });
      Globals.WS.sendMessage(
        MessageFactory.createMessage(
          Protocol.AUTOBET,
          +autorollLogic.bet,
          parseInt(bombs),
          selectedSpheres.join(":")
        )
      );
    }
  };
  handleSelectedSpheres = (e) => {
    const { selectedSpheres } = this.state;
    if (e) {
      if (selectedSpheres.includes(e)) {
        this.setState({
          selectedSpheres: selectedSpheres.filter(
            (selectedSpheres) => selectedSpheres !== e
          ),
        });
      } else {
        this.setState({ selectedSpheres: [...selectedSpheres, e] });
      }
    } else {
      this.setState({ selectedSpheres: [] });
    }
  };

  handleStop = () => {
    let time = 500;
    const setState = this.setState.bind(this);
    this.setState({
      isDisabled: true,
      newDisable: true,
      selectedSpheres: [],
      userSelected: [],
    });
    this.stopTimeout = setTimeout(function () {
      setState({ isDisabled: false, newDisable: false }); // es gadasaketebelia
    }, time);
    clearTimeout(this.disableTimeOut);
    this.toggleIsAutoOn(false);
  };

  handleCashout = () => {
    this.setState({
      newDisable: true,
    });
    this.Globals.WS.sendMessage(
      MessageFactory.createMessage(Protocol.END_ROUND)
    );
  };

  handleInitGame = () => {
    let time = 1000;
    const setState = this.setState.bind(this);
    this.gameTimeOut = setTimeout(function () {
      setState({
        result: false,
        isClickable: true,
        gamePlayAnimation: false,
        explosion: false,
        perfectWin: false,
        isDisabled: false,
      });
      setState((prevState) => ({
        stateRound: {
          ...prevState.stateRound,
          userSelected: [],
        },
      }));
    }, time);
  };
  // toFixed (floorFigure) - function without rounding, crops decimals
  floorFigure(figure, decimals) {
    // if (!decimals) decimals = 2;
    var d = Math.pow(10, decimals);
    return (parseInt(figure * d) / d).toFixed(decimals);
  }

  getBetReply = (id) => {
    this.setState({ betReply: null });
    const getRound = MessageFactory.createMessage(Protocol.GET_ROUND, id);
    return this.Globals.WS.sendMessage(getRound);
  };
  handleVolumeLocal = (e) => {
    this.setState({ volumeLocal: e });
  };

  render() {
    const {
      balance,
      bet,
      user_id,
      bombs,
      userSelected,
      result,
      provablyFairSeeds,
      history,
      above,
      aboveAnim,
      isAutoOn,
      isClickable,
      noSignal,
      autoConfigs,
      selectedSpheres,
      stateRound,
      manualPlay,
      autoSelect,
      gamePlayAnimation,
      aboveSetting,
      aboveSettingAnim,
      autoAnim,
      userSettings,
      perfectWin,
      explosion,
      isDisabled,
      notification,
      notificationfadeOut,
      userInfo,
      errorMsg,
      betReply,
      dynamicSoundChange,
      volumeLocal,
      gameStates,
      newDisable,
    } = this.state;

    return (
      <AppContainer isDisabled={isDisabled} className="appContainer">
        {noSignal ? (
          <NoSignal
            Globals={this.Globals}
            errorMsg={errorMsg}
            userSettings={userSettings}
          />
        ) : (
          <Mines
            balance={balance}
            bet={bet}
            volumeLocal={volumeLocal}
            userId={user_id}
            userInfo={userInfo}
            bombs={bombs}
            autoSelect={autoSelect}
            provablyFair={provablyFairSeeds}
            history={history}
            above={above}
            perfectWin={perfectWin}
            explosion={explosion}
            aboveSetting={aboveSetting}
            aboveAnim={aboveAnim}
            aboveSettingAnim={aboveSettingAnim}
            isAutoOn={isAutoOn}
            autoAnim={autoAnim}
            isClickable={isClickable}
            notifyText={notification}
            autoConfigs={autoConfigs}
            selectedSpheres={selectedSpheres}
            userSelected={userSelected}
            stateRound={stateRound}
            gamePlayAnimation={gamePlayAnimation}
            dynamicSoundChange={dynamicSoundChange}
            userSettings={userSettings}
            isDisabled={isDisabled}
            toggleIsDisabled={this.toggleIsDisabled}
            Globals={this.Globals}
            handleAbove={this.handleAbove}
            handleAboveAnim={this.handleAboveAnim}
            handleSetting={this.handleSetting}
            handleNotification={this.handleNotification}
            handleBetAmount={this.handleBetAmount}
            handleAutoRollLogic={this.handleAutoRollLogic}
            autorollLogic={this.autorollLogic}
            handleResult={this.handleResult}
            toggleClickable={this.toggleClickable}
            handleSelectedSpheres={this.handleSelectedSpheres}
            saveBet={this.saveBet}
            saveMines={this.saveMines}
            handleBombs={this.handleBombs}
            manualPlay={manualPlay}
            result={result}
            handleStartRound={this.handleStartRound}
            handleGameStep={this.handleGameStep}
            handleRandomGameStep={this.handleRandomGameStep}
            handleCashout={this.handleCashout}
            handleAutoRoll={this.handleAutoRoll}
            handleStop={this.handleStop}
            handleAutoSelect={this.handleAutoSelect}
            saveUserSettings={this.saveUserSettings}
            floorFigure={this.floorFigure}
            betReply={betReply}
            getBetReply={this.getBetReply}
            handleVolumeLocal={this.handleVolumeLocal}
            gameStates={gameStates}
            newDisable={newDisable}
          />
        )}
        {notification && (
          <Notification
            notifyText={notification}
            fadeOut={notificationfadeOut}
            handleNotification={this.handleNotification}
            userSettings={userSettings}
          />
        )}
      </AppContainer>
    );
  }
}
export default App;
